module.exports = __webpack_public_path__ + "static/media/dot-circle.07882e1e.svg";